// Packages
import React from "react";
import { useWatch } from "react-hook-form";

// Components
import useComponents from "../../../components";

// Controllers
import useControllers from "../../../../controllers";

// Assets
import useIcons from "../../../../assets/icons";

// Styles
import { StyledMultipleChoiceAddButton } from "./NotificationCreate.styles";

const NotificationCreate = ({ viewMode = false }) => {
  const { useScreenHooks } = useControllers();
  const { useNotification } = useScreenHooks();
  const { useNotificationCreate } = useNotification();
  const {
    id,
    control,
    handleSubmit,
    onSubmit,
    showModal,
    saving,
    handleCloseModal,
    listCountries,
    fields,
    append,
    remove,
    listGroups,
    listEntities,
    listEntitiesById,
    handleEntitiesSelectChange,
    handleSelectGroup,
    controlSearch,
    onChangeSearchGroup
  } = useNotificationCreate(viewMode) || {};

  const reminderEnabled = useWatch({ control, name: "reminder" });

  const {
    ContentWrappers,
    useButtons,
    TextFieldControlled,
    SelectFieldControlled,
    Typography,
    useModals,
    TextAreaFieldControlled,
    SelectMultiFieldControlled,
    CheckboxControlled,
    TimePickerFieldControlled,
    DatePickerFieldControlled,
    FormLabel,
    InputFileControlled,
    AutocompleteFieldControlled,
  } = useComponents();

  const { DefaultModal } = useModals();

  const { DefaultButton } = useButtons();

  const { IconDelete, IconPlus } = useIcons();

  return (
    <div className="bg-white px-16 pt-10 pb-12 mx-24 rounded-lg">
      <form onSubmit={viewMode ? (e) => e.preventDefault() : handleSubmit(onSubmit)}>
        <Typography variant="h3">1. CONFIGURACIÓN GENERAL</Typography>
        <ContentWrappers
          gridColums={["48%", "48%"]}
          gap={{
            row: "0px",
            column: "4%",
          }}
          className="mt-4 items-center"
        >
          <TextFieldControlled
            type="text"
            id="abi-user-name"
            control={control}
            label="Nombre de notificación"
            placeholder="Nombre de notificación"
            name="title"
            disabled={viewMode}
          />

          <AutocompleteFieldControlled
            label={"Grupo membeer para envío"}
            placeholder={"Buscar grupo"}
            name={`search`}
            id={`abi-group`}
            control={controlSearch}
            options={listGroups}
            onKeyUp={onChangeSearchGroup}
            onChangeValue={handleSelectGroup}
            className="mb-0"
            disabled={viewMode}
          />
        </ContentWrappers>
        <ContentWrappers
          gridColums={["48%", "48%"]}
          gap={{
            row: "0px",
            column: "4%",
          }}
          className="items-center"
        >
          <CheckboxControlled
            id="abi-user-reminder"
            control={control}
            label="Activar recordatorios"
            name="reminder"
            disabled={viewMode}
          />
          <div>
            <FormLabel label="Fecha de publicación" />
            <ContentWrappers
              gridColums={["140px", "100px", "81px"]}
              gap={{
                row: "0px",
                column: "16px",
              }}
            >
              <DatePickerFieldControlled
                name="publicDate"
                id="abi-task-publicDate"
                control={control}
                disabled={viewMode}
              />
              <TimePickerFieldControlled
                name="publicTime"
                id="abi-task-publicTime"
                control={control}
                disabled={viewMode}
              />
              <SelectFieldControlled
                name="publicAmpm"
                id="abi-task-publicAmpm"
                control={control}
                defaultValue={"am"}
                disabled={viewMode}
                options={[
                  {
                    value: "am",
                    label: "a.m",
                  },
                  {
                    value: "pm",
                    label: "p.m",
                  },
                ]}
              />
            </ContentWrappers>
          </div>
        </ContentWrappers>
        {reminderEnabled && (
        <div>
          <Typography variant="h3">1.1. AGREGAR RECORDATORIOS</Typography>
          {fields?.map((item, index) => (
            <div key={item.id} className="py-4">
              <div className="flex items-center space-x-2">
                <Typography variant="h4">RECORDATORIO {index + 1}</Typography>
                <div
                  className={`cursor-pointer ${(index === 0 || viewMode) && "hidden"}`}
                  onClick={() => remove(index)}
                >
                  <IconDelete />
                </div>
              </div>
              <ContentWrappers
                gridColums={["395px", "8%"]}
                gap={{
                  row: "0px",
                  column: "4%",
                }}
                className="items-center"
              >
                <div>
                  <FormLabel label="Fecha y hora de inicio" />
                  <ContentWrappers
                    gridColums={["178px", "100px", "81px"]}
                    gap={{
                      row: "0px",
                      column: "16px",
                    }}
                  >
                    <DatePickerFieldControlled
                      name={`reminders[${index}].date`}
                      id={`reminders[${index}].date`}
                      control={control}
                      disabled={viewMode}
                    />
                    <TimePickerFieldControlled
                      name={`reminders[${index}].time`}
                      id={`reminders[${index}].time`}
                      control={control}
                      disabled={viewMode}
                    />
                    <SelectFieldControlled
                      name={`reminders[${index}].ampm`}
                      id={`reminders[${index}].ampm`}
                      control={control}
                      defaultValue={"am"}
                      disabled={viewMode}
                      options={[
                        {
                          value: "am",
                          label: "a.m",
                        },
                        {
                          value: "pm",
                          label: "p.m",
                        },
                      ]}
                    />
                  </ContentWrappers>
                </div>
                <StyledMultipleChoiceAddButton>
                  {!viewMode && (
                    <button onClick={() => append()} type="button">
                      <IconPlus />
                    </button>
                  )}
                </StyledMultipleChoiceAddButton>
              </ContentWrappers>
            </div>
          ))}
        </div>
        )}
        <Typography variant="h3">2.Tipo de notificación</Typography>
        <div className="flex flex-col space-y-4 mt-4">
          <CheckboxControlled
            id="abi-user-reminder-push"
            control={control}
            label="Notificación Push"
            name="reminder_push"
            disabled={viewMode}
          />

          <ContentWrappers
            gridColums={["48%", "48%"]}
            gap={{
              row: "0px",
              column: "4%",
            }}
            className="mt-4 items-center w-full"
          >
            <SelectFieldControlled
              label={"Tipo"}
              placeholder={"Selecciona una opción"}
              name={`entity`}
              id={`abi-entities`}
              onChangeField={(data) => handleEntitiesSelectChange(data)}
              control={control}
              options={listEntities}
              disabled={viewMode}
            />

            <AutocompleteFieldControlled
              label={"Listado"}
              placeholder={"Selecciona una opción"}
              name={`entity_id`}
              id={`abi-entity-id`}
              control={control}
              options={listEntitiesById}
              disabled={viewMode || listEntitiesById?.length === 0}
              isOptionEqualToValue={(option, value) => option?.value === value?.value}
              renderOption={(props, option) => (
                <li {...props} key={option.value}>
                  {option.label}
                </li>
              )}
            />
          </ContentWrappers>

          <TextAreaFieldControlled
            label={"Mensaje"}
            placeholder={"Escribe aquí el mensaje"}
            name={`message_push`}
            id={`abi-notification-message-push`}
            control={control}
            disabled={viewMode}
          />
          <CheckboxControlled
            id="abi-user-reminder-email"
            control={control}
            label="Correo electrónico"
            name="reminder_email"
            disabled={viewMode}
          />
          <TextFieldControlled
            type="text"
            id="abi-asunto-email"
            control={control}
            label="Asunto del correo"
            placeholder="Asunto correo electrónico"
            name="email_subject"
            disabled={viewMode}
          />
          <InputFileControlled
            label={"Agregar cabezote (jpg, png, webp)"}
            placeholder={"image.jpg"}
            name={`header_image`}
            id={`abi-notification-image-email`}
            control={control}
            directPreview
            maxFiles={1}
            showPreview
            disabled={viewMode}
          />
          <TextAreaFieldControlled
            label={"Mensaje personalizado"}
            placeholder={"Escribe aquí el mensaje"}
            name={`message_email`}
            id={`abi-notification-message-email`}
            control={control}
            disabled={viewMode}
          />
        </div>
        {!viewMode && (
          <div className="text-center mt-4">
            <DefaultButton color="secondary" type="submit" disabled={saving}>
              Finalizar y publicar
            </DefaultButton>
          </div>
        )}
      </form>
      <DefaultModal isOpen={showModal}>
        <div className="flex items-center flex-col space-y-8">
          {id && (
            <Typography variant="body2">
              La notificación <b>{id ? id : ""}</b> se ha modificado con éxito.
            </Typography>
          )}
          {!id && <Typography variant="body2">La notificación se ha creado con éxito.</Typography>}
          <DefaultButton color="success" onClick={handleCloseModal}>
            Aceptar
          </DefaultButton>
        </div>
      </DefaultModal>
    </div>
  );
};

export default NotificationCreate;
